<template>
  <div
    :class="`subheadline subheadline--${fontWeight} subheadline--size-${fontSize}`">
    <slot />
  </div>
</template>

<script>

export default {
  name: "Subheadline",
  props: {
    fontWeight: {
      type: String,
      default: "normal",
      required: false
    },
    fontSize: {
      type: String,
      default: "medium",
      required: false
    }
  }
};
</script>

<style lang="scss" scoped>
.subheadline {

  @include font-style(p1, $color: $midnight);

  ::v-deep mark { /*stylelint-disable-line  */
    @include highlight($size: 70%);
  }

  &--medium {
    @include font-weight(normal);

    font-family: $base-font-stack-sansserif-medium;
  }

  &--size-small {
    @include font-style(p1, $color: $midnight);
    @include media(min-width, m) {
      @include font-style(p1, $color: $midnight);
    }
  }

  &--size-medium {
    @include media(min-width, m) {
      @include font-style(p0, $color: $midnight);

      &--medium {
        @include font-weight(normal);

        font-family: $base-font-stack-sansserif-medium;
      }
    }
  }
}
</style>
